import { render } from "./OptionsMenu.vue?vue&type=template&id=b03f4a24"
import script from "./OptionsMenu.vue?vue&type=script&lang=js"
export * from "./OptionsMenu.vue?vue&type=script&lang=js"

import "./OptionsMenu.vue?vue&type=style&index=0&id=b03f4a24&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__